import { render, staticRenderFns } from "./CreateFtpUser.vue?vue&type=template&id=5d887992&"
import script from "./CreateFtpUser.vue?vue&type=script&lang=ts&"
export * from "./CreateFtpUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports